const CART_CHECKOUT_TYPES = {
  HEPSIBURADA: '0',
  OTHER: '4',
};

const CART_ACTION_STATE = 'ADD_TO_CART';

const DEFAULT_QUANTITY_FOR_CART = 1;

const ADD_TO_CART = {
  TITLE: {
    SUCCESS: 'Ürün sepete eklendi',
    FAIL: 'Ürün sepete eklenemedi',
  },
  MESSAGE: {
    FAIL: 'Tekrar deneyin veya genel bir problem olduğunu düşünüyorsanız Çözüm Merkezi\'mize başvurun.',
  },
  TYPE: {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
  },
};

export {
  CART_ACTION_STATE,
  CART_CHECKOUT_TYPES,
  DEFAULT_QUANTITY_FOR_CART,
  ADD_TO_CART,
};
